import * as React from 'react';
import { cn } from '@/lib/utils';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {}

/**
 * Checkbox primitive (T-202 Slice 8) — the single owner of checkbox chrome.
 * A thin wrapper over the native `<input type="checkbox">` styled with semantic
 * tokens (`accent-primary` colours the check), so existing `checked`/`onChange`
 * handlers map 1:1. Replaces ad-hoc bare `<input type="checkbox">`.
 */
const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <input
      type="checkbox"
      ref={ref}
      className={cn(
        'h-4 w-4 shrink-0 cursor-pointer rounded border border-surface/25 text-primary accent-primary',
        'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
